/**
 * @name 图标
 */
import base from '../../base';
import Modal from './modal';

Modal.install = function(Vue) {
  Vue.use(base);
  Vue.component(Modal.name, Modal);
};

export default Modal;
